export const normalizeEmailDomain = (value?: string | null) => {
  if (!value) {
    return '';
  }

  return value.trim().toLowerCase().replace(/^@+/u, '');
};

export const parseEmailDomains = (value?: string | null) => {
  if (!value) {
    return [];
  }

  const domains: Array<string> = [];

  for (const part of value.split(',')) {
    const domain = normalizeEmailDomain(part);

    if (domain && !domains.includes(domain)) {
      domains.push(domain);
    }
  }

  return domains;
};

export const formatEmailDomains = (value?: string | null) =>
  parseEmailDomains(value).join(', ');

export const isValidEmailDomain = (domain: string) =>
  domain.includes('.') && !domain.includes('@');

export const areEmailDomainsValid = (value?: string | null) => {
  const domains = parseEmailDomains(value);

  return (
    domains.length > 0 && domains.every((domain) => isValidEmailDomain(domain))
  );
};

export const extractEmailDomain = (email: string) => {
  const domain = email.split('@')[1];

  return domain ? normalizeEmailDomain(domain) : '';
};

export const emailMatchesCompanyDomain = (
  email: string,
  companyDomain?: string | null,
) => {
  const expectedDomains = parseEmailDomains(companyDomain);

  if (expectedDomains.length === 0) {
    return true;
  }

  return expectedDomains.includes(extractEmailDomain(email));
};
